import { createFileRoute } from "@tanstack/react-router";
import { TradeGuidePage, seoHead } from "@/components/hubs/HubPages";
import { TRADE_GUIDES } from "@/lib/regionalHubs";

const DATA = TRADE_GUIDES.find((x) => x.slug === "/learn/roofing-leads-colorado")!;

export const Route = createFileRoute("/learn/roofing-leads-colorado")({
  head: () => seoHead("/learn/roofing-leads-colorado", "How Colorado Roofers Get More Leads | Guide", "Plain-English guide for Colorado roofers: Google Maps, storm pages, reviews, and ads that bring in your own calls.", "article"),
  component: () => <TradeGuidePage guide={DATA} />,
});
